/**
 * Updates the document's head tags for SEO.
 * @param {Object} meta 
 * @param {string} meta.title
 * @param {string} meta.description
 * @param {string} meta.keywords
 * @param {string} meta.image
 * @param {string} meta.favicon
 */
export const updateMetaTags = ({ title, description, keywords, image, favicon, siteName = 'Ortus' }) => {
  // Title
  if (title) {
    document.title = title.includes(siteName) ? title : `${title} | ${siteName}`;
  } else {
    document.title = siteName;
  }

  // Favicon
  if (favicon) {
    updateOrCreateLink('icon', favicon);
    updateOrCreateLink('shortcut icon', favicon);
    updateOrCreateLink('apple-touch-icon', favicon);
  }

  // Description
  updateOrCreateMeta('description', description);
  updateOrCreateMeta('og:description', description);

  // Keywords
  updateOrCreateMeta('keywords', keywords);

  // Open Graph
  updateOrCreateMeta('og:title', title);
  updateOrCreateMeta('og:type', 'website');
  if (image) {
    updateOrCreateMeta('og:image', image);
  }

  // Canonical (optional, but good)
  updateOrCreateLink('canonical', window.location.href);
};

function updateOrCreateMeta(name, content) {
  if (!content) return;
  
  const selector = name.startsWith('og:') ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let element = document.querySelector(selector);
  
  if (!element) {
    element = document.createElement('meta');
    if (name.startsWith('og:')) {
      element.setAttribute('property', name);
    } else {
      element.setAttribute('name', name);
    }
    document.head.appendChild(element);
  }
  
  element.setAttribute('content', content);
}

function updateOrCreateLink(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
}
